import { Component, Input, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { TemplateService } from '@app/core/services/template.service';
import {
    CategoryTemplateList,
    Template,
    TemplateCategories,
    TemplateVersion
} from '@app/shared/models/distribution-doc-models';
import { FileTypes } from '@app/shared/models/file-type';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TextAreaDialogComponent } from '@app/shared/dialogs/text-area-dialog/text-area-dialog.component';
import { CdkDragDrop, CdkDragSortEvent } from '@angular/cdk/drag-drop';
import { TranslationEntry } from '@app/shared/models/translatable';


@Component({
    selector: 'template-category',
    templateUrl: './template-category.component.html',
    styleUrls: ['./template-category.component.scss']
})
export class TemplateCategoryComponent extends BaseWithBundleComponent
                                       implements OnInit {

    @Input()
    public categoryTemplateList: CategoryTemplateList;
    
    public acceptedFilesTypes: FileTypes[];

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected templateService: TemplateService,
                protected fileUtilityService: FileUtilityService) {
        super(componentServiceBundle);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.acceptedFilesTypes = FileTypes.TYPES_TEMPLATE;
    }

    public createTemplateVersion(file: File): void {
        const newTemplateVersion = new TemplateVersion();
        newTemplateVersion.filename = file.name;
        newTemplateVersion.template_category = TemplateCategories.getByKey(this.categoryTemplateList.name);

        const dialogRef = this.dialog.open(TextAreaDialogComponent, {
            width: '400px',
            data: {
                title: `${this.translateService.instant(marker('common.dialog.upload.title'), { fileName: newTemplateVersion.filename })}`,
                confirmBtnOverride: marker('common.btn.upload'),
                closeBtnOverride: marker('common.btn.cancel'),
                label: newTemplateVersion.trans.description
            }
        });

        dialogRef.afterClosed()
            .subscribe((modalResult: { text: string }) => {
                if (modalResult) {
                    if (modalResult && modalResult.text) {
                        newTemplateVersion.description = modalResult.text;
                    }

                    this.fileUtilityService.fileAsBinaryString(file)
                        .subscribe((fileAsBinaryString) => {
                                this.templateService.createTemplate(fileAsBinaryString, newTemplateVersion, this.categoryTemplateList.nextOrder)
                                                    .subscribe((result: Template) => {
                                    this.categoryTemplateList.addItem(result);
                                }, err => {
                                    this.handleError(err);
                                });
                        });
                }
            });
    }

    public createTemplate(files: File[]): void {
        if (files && files.length > 0) {
            this.createTemplateVersion(files[0]);
        }
    }

    public setNewTemplateOrder(dragDrop: CdkDragDrop<any>): void {
        this.templateService.reorderTemplates(this.categoryTemplateList)
                            .subscribe((result) => {
            this.categoryTemplateList = result;
        }, err => this.handleError(err));
    }

    public swapTemplates(sortEvent: CdkDragSortEvent<any>): void {
        this.categoryTemplateList.switchItems(sortEvent.previousIndex, sortEvent.currentIndex);
    }

}
